/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileSheets16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13.499 3c.277 0 .501.228.501.51v8.98c0 .282-.23.51-.501.51H3.5a.505.505 0 01-.5-.51V3.51c0-.282.23-.51.501-.51H13.5zM4 10v2h4V9.999L4 10zm5 0v2h4v-2H9zm4-3H9v2h4V7zm0-3H9v2h4V4zM8 4H4v2l4-.001V4zM4 9l4-.001v-2L4 7v2z"
        />
    </AccessibleSVG>
);

export default FileSheets16;
